<template>

    <div>

        <div class="w-full mb-4">

            <span class="text-xl sm:text-1.5xl md:text-2.25xl lg:text-2.5xl xl:text-2.25xl text-black uppercase tracking-[.2rem] font-medium text-left relative">
                {{ price }} €
            </span>

        </div>

        <hr/>

        <div v-if="product.available_for_order" class="position-relative flex flex-col w-full space-y-6">

            <div class="w-full flex flex-col space-y-6 uppercase pt-5">
                <span v-show="product.type == 'vini'" class="flex flex-col space-y-1">
                    <span class="text-black text-xs sm:text-sm xl:text-xs">
                        {{$root.translateString('year')}}
                    </span>
                    <span class="flex-grow">
                        <select class="w-full pt-0 pb-2 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none appearance-none" @change="selectYear($event.target.value)">
                            <option v-for="(year, index) in years" :key="index" :value="year.value" v-text="year.name" :selected="selected_year == year.value"></option>
                        </select>
                        <!-- <div class="absolute right-0 top-0 flex items-center h-full w-[12px] pointer-events-none">
                            <svg class="w-full h-auto" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                width="9.21346px" height="5.31389px" viewBox="0 0 9.21346 5.31389" style="enable-background:new 0 0 9.21346 5.31389;"
                                xml:space="preserve">
                            <g>
                                <g>
                                    <g>
                                        <polyline fill="none" stroke-miterlimit10 stroke="#C9C8C0" class="st3" points="0.35356,0.35356 4.60656,4.60678 8.85991,0.35356 			"/>
                                    </g>
                                </g>
                            </g>
                            </svg>
                        </div> -->
                    </span>
                </span>
                <span class="flex flex-col space-y-1">
                    <span class="text-black text-xs sm:text-sm xl:text-xs">
                        {{$root.translateString('format')}}
                    </span>
                    <span class="flex-grow">
                        <select class="w-full pt-0 pb-2 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none appearance-none" @change="selectFormat($event.target.value)">
                            <option v-for="(format, index) in formats" :key="index" :value="format.value" v-text="format.size" :selected="selected_format == format.value"></option>
                        </select>
                        <!-- <div class="absolute right-0 top-0 flex items-center h-full w-[12px] pointer-events-none">
                            <svg class="w-full h-auto" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                width="9.21346px" height="5.31389px" viewBox="0 0 9.21346 5.31389" style="enable-background:new 0 0 9.21346 5.31389;"
                                xml:space="preserve">
                            <g>
                                <g>
                                    <g>
                                        <polyline fill="none" stroke-miterlimit10 stroke="#C9C8C0" class="st3" points="0.35356,0.35356 4.60656,4.60678 8.85991,0.35356 			"/>
                                    </g>
                                </g>
                            </g>
                            </svg>
                        </div> -->
                    </span>
                </span>
            </div>

            <div class="relative w-full flex flex-col space-y-8">

                <div class="inline-flex my-4">

                    <div class="flex-grow flex items-center">
                        <span class="text-black text-xs sm:text-sm xl:text-xs block !leading-none">
                            {{$root.translateString('quantity')}}
                        </span>
                        <span class="text-primary italic px-2.5 text-xbase sm:text-xlg xl:text-xbase font-medium pb-0.5 xl:pb-1">
                            {{ buy.qty }}
                        </span>
                    </div>

                    <div class="flex items-center space-x-2.5">
                        <button @click="decreaseQty" type="buttton" class="w-7.5 h-7.5 flex justify-center items-center xl:hover:opacity-80 transition-all">
                            <img class="w-full h-full" src="/images/svg/ico-minus.svg" alt="icona" />
                        </button>

                        <button @click="increaseQty" type="buttton" class="w-7.5 h-7.5 flex justify-center items-center xl:hover:opacity-80 transition-all">
                            <img class="w-full h-full" src="/images/svg/ico-plus.svg" alt="icona" />
                        </button>
                    </div>

                </div>

                <div class="flex-grow flex flex-col !mt-3">
                    <button @click="addToCart" type="button" class="relative w-full lg:px-16 py-5 flex items-center bg-customGray-background transition-all !duration-500 mx-auto mb-5 xl:mb-0 xl:hover:!rounded-lg group">
                        <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                        <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                        <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                            {{$root.translateString('add_to_cart')}}
                        </span>
                    </button>
                </div>

            </div>

            <div v-if="added_to_cart" class="-mt-8 xl:mt-0">
                <span class="text-primary w-full text-xs sm:text-sm xl:text-xs uppercase block text-center xl:text-left italic tracking-[.1rem]">{{$root.translateString('added_to_cart')}}</span>
            </div>

        </div>

        <div v-else class="relative w-full">
            <p class="text-black my-5 text-left text-xs sm:text-sm xl:text-xs uppercase">{{$root.translateString('not_available')}}</p>
        </div>

    </div>
</template>

<script>
export default {
    props: ['productProp', 'qsFormat', 'qsYear', 'qsAdwordsProp', 'lang', 'isLogged'],
    data() {
        return {
            main_selector: 'year',
            default_format: 'bottiglia',
            default_year: '',
            selected_code: '',
            selected_format: '',
            selected_year: '',
            product: null,
            qsAdwords: typeof this.qsAdwordsProp != 'undefined' ? this.qsAdwordsProp : null,
            guest_vintage: 0,
            is_logged: false,
            combinations: {
            },
            formats: [],
            years: [],
            buy: {
                type: 'product',
                id: null,
                qty: 1
            },
            added_to_cart: false,
        }
    },
    created() {

        this.product = this.productProp;

        if(this.product.type == 'vini') {
            this.buy.qty = 1;
        }

        if(this.isLogged) {
            this.is_logged = true;
        }

        if(['accessori', 'gift-card'].includes(this.product.type)) {
            this.default_format = this.product.combinations[0].code;
            this.main_selector = this.product.combinations[0].code;
        }

        this.product.combinations.sort(function(a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });

        this.buy.id = this.product.id;

        let tmp_first_format = '';
        let default_format_exist = false;
        let tmp_formats = [];

        let tmp_first_year = '';
        let default_year_exist = false;
        let tmp_years = [];

        for (let [key, combination] of Object.entries(this.product.combinations)) {

            let weight = 1;

            if(typeof combination.weight != 'undefined') {
                weight = parseFloat(combination.weight);
            }

            this.combinations[combination.code] = {
                code: combination.code,
                price: combination.price,
                weight: weight,
                attributes: {}
            };

            if(combination.attributes.length > 0) {

                for (let attribute of combination.attributes) {
                    this.combinations[combination.code].attributes[attribute.key] = attribute;

                    if(attribute.key == 'formato' && !tmp_formats.includes(attribute.value)) {

                        if(key == 0) {
                            tmp_first_format = attribute.value;
                        }

                        if(attribute.value == this.default_format) {
                            default_format_exist = true;
                        }

                        tmp_formats.push(attribute.value);

                        this.formats.push({
                            value: attribute.value,
                            name: attribute.value_label,
                            size: attribute.value_clean,
                            combination: combination.code
                        })
                    }

                    // console.log(this.formats)

                    if(attribute.key == 'anno' && !tmp_years.includes(attribute.value)) {

                        if(tmp_first_year < attribute.value) {
                            tmp_first_year = attribute.value;
                        }

                        tmp_years.push(attribute.value);

                        this.years.push({
                            value: attribute.value,
                            name: attribute.value_label,
                            combination: combination.code
                        })
                    }

                }

            }
        }


        this.years.sort(function(a, b) {
            return parseFloat(b.value) - parseFloat(a.value);
        });


        /**/

        //select wine from querystring

        if(this.product.type == 'vini') {
            if(typeof this.qsFormat != 'undefined' && this.qsYear != 'undefined') {

                if(this.qsYear != null && tmp_years.includes(parseInt(this.qsYear))) {
                    this.selectYear(parseInt(this.qsYear));
                }else{
                    if(default_year_exist == true) {
                        this.selectYear(this.default_year);
                    } else {
                        this.selectYear(tmp_first_year);
                    }
                }

                if(this.qsFormat != null && tmp_formats.includes(this.qsFormat)) {
                    this.selectFormat(this.qsFormat.toLowerCase());
                }else{
                    if(default_format_exist == true) {
                        this.selectFormat(this.default_format);
                    } else {
                        this.selectFormat(tmp_first_format);
                    }
                }
            }
        }

    },
    mounted() {

        fbq('track', 'ViewContent',
            {
                value: parseFloat(this.price),
                currency: 'EUR',
                content_ids: this.product.id,
                content_type: 'product',
                content_name: this.product.name
            }
        );

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                items: [
                    {
                        item_name: this.product.name.replace('<br>', ' '),
                        item_id: this.product.id,
                        price: String(this.price).replace(',', '.'),
                        item_brand: '-',
                        quantity: 1,
                        item_category: this.type,
                        item_variant: this.selected_format + ' - ' + this.selected_year
                    }
                ]
            }
        })

        /*if(this.product.type == 'vini') {

            this.product.combinations.forEach((elem) => {
                let split = elem.code.split('-');
                if (split[0].toLowerCase() == 'bottiglia') {
                    if(this.guest_vintage < parseInt(split[1])) {
                        this.guest_vintage = parseInt(split[1]);
                    }
                }

            })

        }*/

    },
    methods: {
        cleanFormat(format) {
            return format
        },
        decreaseQty() {
            if(this.buy.qty > 1) {
                this.buy.qty -= 1;
            }else{
                this.buy.qty = 1;
            }
        },
        increaseQty() {
            if(this.buy.qty < 30) {
                this.buy.qty += 1;
            }else{
                this.buy.qty = 30;
            }
        },
        summonPopup()
        {
            this.$eventHub.$emit('register', {});
        },
        selectFormat(format)
        {
            if(this.main_selector == 'formato') {
                this.years = [];
                for (let [k, c] of Object.entries(this.combinations)) {
                    if(c.attributes.formato.value == format) {
                        //console.log(c);
                        if(typeof c.attributes.anno != 'undefined') {
                            this.years.push({
                                value: c.attributes.anno.value,
                                name: c.attributes.anno.value_label,
                                combination: c.code
                            });
                        } else {
                            //se non abbiamo l'anno è singola.
                            this.selected_code = c.code;
                        }
                    }
                }

                if(this.years.length > 0) {
                    this.selected_year = this.years[0].value;
                    this.selected_code = this.years[0].combination;
                } else {
                    this.selected_year = null;
                }
            } else {
                this.formats.forEach(y => {
                    if(y.value == format) {
                        this.selected_code = y.combination;
                    }
                });
            }

            this.selected_format = format;

            let format_qs = '?format=' + this.selected_format;
            let year_qs = '&year=' + this.selected_year;
            if(this.selected_format == '') {
                format_qs = '';
            }
            if(this.selected_year == '') {
                year_qs = '';
            }
            // if(this.qsAdwords == null && this.product.type == 'vini'  && this.selected_year != '') {
            //     if(this.product.category != null) {
            //         history.replaceState({}, this.product.name, '/' + this.lang + '/wine-club/shop/' + this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.category + '/' + this.product.link_rewrite + format_qs + year_qs);
            //     }else{
            //         history.replaceState({}, this.product.name, '/' + this.lang + '/wine-club/shop/' + this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.link_rewrite + format_qs + year_qs);
            //     }
            // }

            if(typeof this.qsAdwords != null) {
                this.qsAdwords = null;
            }

        },
        selectYear(year)
        {

            this.formats = [];
            let local_default_format_exist = null;
            if(this.main_selector == 'year') {
                for (let [k, c] of Object.entries(this.combinations)) {
                    //console.log(c.attributes.anno.value +" - "+ year);
                    if(c.attributes.anno.value == year) {

                        if(typeof c.attributes.anno != 'undefined') {
                            this.formats.push({
                                value: c.attributes.formato.value,
                                name: c.attributes.formato.value_label,
                                size: c.attributes.formato.value_clean,
                                combination: c.code
                            });
                            if(typeof this.default_format != 'undefined' && this.default_format != null) {
                                if(c.attributes.formato.value === this.default_format) {
                                    local_default_format_exist = {
                                        value: c.attributes.formato.value,
                                        combination: c.code
                                    };
                                }
                            }
                        } else {
                            //se non abbiamo il formato è singola.
                            this.selected_code = c.code;
                        }
                    }
                }

                if(this.formats.length > 0) {

                    if(local_default_format_exist !== null) {
                        this.selected_format = local_default_format_exist.value;
                        this.selected_code = local_default_format_exist.combination;
                    } else {
                        this.selected_format = this.formats[0].value;
                        this.selected_code = this.formats[0].combination;
                    }
                } else {
                    this.selected_year = null;

                }
            } else {
                this.years.forEach(y => {
                    if(y.value == year) {
                        this.selected_code = y.combination;
                    }
                });
            }

            this.selected_year = year;

            // if(this.qsAdwords == null && this.product.type == 'vini' && this.selected_year != '') {
            //     if(this.product.category != null) {
            //         history.replaceState( {} , this.product.name, '/' + this.lang + '/wine-club/shop/' + this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.category + '/' + this.product.link_rewrite + '?format=' + this.selected_format + '&year=' + this.selected_year );
            //     }else{
            //         history.replaceState( {} , this.product.name, '/' + this.lang + '/shop/' +  this.$root.slugifyType(this.lang, this.product.type) + '/' + this.product.link_rewrite + '?format=' + this.selected_format + '&year=' + this.selected_year );
            //     }
            // }

        },
        addToCart()
        {
            this.buy.combination = this.combinations[this.selected_code];

            if(['gift-card'].includes(this.product.type)) {
                this.buy.combination.attributes = [];
            }

            axios.post('/api/cart/add', this.buy)
                .then(response => {
                    if(response.data.status === true) {

                        fbq('track', 'AddToCart',
                            {
                                value: parseFloat(this.price),
                                currency: 'EUR',
                                contents: [
                                    {
                                        id: this.product.name,
                                        quantity: this.buy.qty
                                    },
                                ],
                                content_type: 'product',
                                content_name: this.product.name
                            }
                        );

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.product.name.replace('<br>', ' '),
                                        item_id: this.product.id,
                                        price: String(this.price).replace(',', '.'),
                                        item_brand: '',
                                        item_category: this.type,
                                        item_variant: this.selected_format + ' - ' + this.selected_year,
                                        quantity: this.buy.qty,
                                    }
                                ]
                            }
                        });

                        let buy_qty_memo = this.buy.qty;
                        this.$eventHub.$emit('cart.added', {
                            count: response.data.count,
                            specific_count: buy_qty_memo,
                            product_id: this.product.id,
                            product_code: this.selected_code
                        });

                        if(window.innerWidth >= 1280) {
                            this.$eventHub.$emit('cart.show', {});
                        }

                        this.added_to_cart = true;
                        if(this.product.type == 'vini') {
                            this.buy.qty = 1;
                        }else{
                            this.buy.qty = 1;
                        }
                        this.buy.combination = null;
                        this.selectFormat(this.default_format);
                        setTimeout(() => {
                            this.added_to_cart = false;
                        }, 4000);
                    }

                })
                .catch(err => {
                    //console.log('Error');
                });
        },
    },
    computed: {
        // isBuyableByGuest()
        // {
        //     if(this.product.type != 'vini' || this.is_logged) {
        //         return true
        //     }
        //     return (this.selected_year == this.guest_vintage && this.selected_format == 'bottiglia');
        // },
        price()
        {
            if(this.selected_code == '') this.selected_code = this.default_format;
            let base = this.combinations[this.selected_code].price;
            //let qty = this.buy.qty;
            let qty = 1;
            /*if(this.product.type == 'vini') {
                qty = 1;
            }*/
            return this.$root.currencyDisplaySimple(base * qty);
        }
    }
}
</script>
